import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  KEY__CREDENTIAL__PRIMARY,
  KEY__CREDENTIAL__SECONDARY
} from '../../dictionaries/Credential.dic';
import Core from '../../lib/Core';
import {
  ACCOUNT_ACTION__MANAGE_GOOGLE
} from '../../lib/Definition';
import Google from '../../lib/Google';
import {
  reloadLocation
} from '../../lib/URL.lib';
import {
  showConfirm
} from '../Dialogs/AppConfirmationDialog';
import Box from '../Layout/Wrappers/Box';
import Button from '../Layout/Wrappers/Button';
import Fieldset from '../Layout/Wrappers/Fieldset';
import Icon from '../Layout/Wrappers/Icon';
import List from '../Layout/Wrappers/List';
import {
  Label
} from '../Layout/Wrappers/Typography';
import useState from '../../lib/hooks/useState.hook';
import Once from '../Layout/Wrappers/Once';

export default function AccordionGSuite() {
  const [state, updateState] = useState({
    expand: true,
  });

  const toggleCollapse = (event) => {
    updateState({ expand: !state.expand });
  };

  return (
    <List className='m-0 p-0'>
      <ListItemButton onClick={toggleCollapse}>
        <ListItemIcon>
          <Icon icon='build' />
        </ListItemIcon>
        <ListItemText
          primary="G-Suite integration"
        />
        <Once
          promise={async () => {
            setTimeout(
              async () => {
                if (Core.isAdminOrCoordinator()) {
                  updateState({
                    isPrimaryConnected: await Google.isConnected(KEY__CREDENTIAL__PRIMARY),
                    isSecondaryConnected: await Google.isConnected(KEY__CREDENTIAL__SECONDARY),
                  });
                }
              }, 1000
            );
          }}
        />
        <Icon icon={
          state.expand
            ? 'expand_less'
            : 'expand_more'}
        />
      </ListItemButton>
      <Collapse in={state.expand} timeout="auto" unmountOnExit>
        <Box row wrap className='bg-white-dark rounded'>
          <Fieldset
            acl={Core.isAdmin({ action: ACCOUNT_ACTION__MANAGE_GOOGLE })}
            title={
              <Label className='tt-none'>
                Primary G-Suite account
              </Label>
            }
          >
            <Button
              variant='contained'
              color={!!state.isPrimaryConnected ? 'success' : 'secondary'}
              size='small'
              startIcon={!!state.isPrimaryConnected && (<i className="material-icons c-inherit">check</i>)}
              className='tt-unset min-w-240'
              onClick={(event) => {
                if (!state.isPrimaryConnected) {
                  Core.showLoader();
                  Google.connect(KEY__CREDENTIAL__PRIMARY);
                }
                else {
                  showConfirm({
                    title: 'Remove Access?',
                    message: 'This action will remove Google credentials',
                    onAcceptLabel: 'Revoke Token',
                    onAccept: (event) => {
                      Core.showLoader();
                      Google.disconnect(
                        KEY__CREDENTIAL__PRIMARY
                      ).then(
                        (response) => Core.showWarning(
                          'Default G-Suite account now is disconnected',
                          onClose => reloadLocation()
                        )
                      ).catch(
                        (error) => Core.showError(
                          error,
                          onClose => reloadLocation()
                        )
                      );
                    }
                  })
                }
              }}
            >
              {!!state.isPrimaryConnected ? "Connected with Google" : "Connect with Google"}
            </Button>
          </Fieldset>
          <Fieldset
            acl={Core.isAdmin({ action: ACCOUNT_ACTION__MANAGE_GOOGLE })}
            title={
              <Label className='tt-none'>
                Secondary G-Suite account
              </Label>
            }
          >
            <Button
              variant='contained'
              color={!!state.isSecondaryConnected ? 'success' : 'secondary'}
              size='small'
              startIcon={!!state.isSecondaryConnected && (<i className="material-icons c-inherit">check</i>)}
              className='tt-unset min-w-240'
              onClick={(event) => {
                if (!state.isSecondaryConnected) {
                  Core.showLoader();
                  Google.connect(KEY__CREDENTIAL__SECONDARY);
                }
                else {
                  showConfirm({
                    title: 'Remove Access?',
                    message: 'This action will remove Google credentials',
                    onAcceptLabel: 'Revoke Token',
                    onAccept: (event) => {
                      Core.showLoader();
                      Google.disconnect(KEY__CREDENTIAL__SECONDARY).then(
                        (response) => Core.showWarning(
                          'Additional G-Suite account now is disconnected',
                          onClose => reloadLocation()
                        )
                      ).catch(
                        (error) => Core.showError(
                          error,
                          onClose => reloadLocation()
                        )
                      );
                    }
                  })
                }
              }}
            >
              {!!state.isSecondaryConnected ? "Connected with Google" : "Connect with Google"}
            </Button>
          </Fieldset>
        </Box>
      </Collapse>
    </List>
  );
}
